var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "the_top_nav_bar c-flex justify-space-around no-gap",
    staticStyle: {
      "align-items": "center",
      "background-color": "#323a45",
      "box-shadow": "0 4px 5px rgba(0, 0, 0, 0.25)",
      "color": "#ffffff",
      "height": "100%",
      "position": "sticky",
      "top": "0",
      "z-index": "11"
    }
  }, [_c('div', {
    staticClass: "left_side c-flex align-items-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "nav_bar_item ml-2"
  }, [_c('TheSideNav', {
    attrs: {
      "application-version": _vm.applicationVersion
    },
    on: {
      "show_application_change_log": _vm.emitShowApplicationChangeLog
    },
    scopedSlots: _vm._u([{
      key: "side_menu_items",
      fn: function () {
        return [_vm._t("side_menu_items")];
      },
      proxy: true
    }], null, true)
  })], 1), _c('div', {
    staticClass: "nav_bar_item logo c-flex align-items-center justify-center"
  }, [_vm._t("nav_bar_logo")], 2), _vm.shouldShowNewBrowserWindowIcon ? _c('div', {
    ref: "new_tab_icon",
    staticClass: "nav_bar_item new_tab_icon c-flex align-items-center justify-center"
  }, [_c('a', {
    staticClass: "new_tab c-flex align-items-center justify-center",
    staticStyle: {
      "padding": "3px",
      "height": "100%"
    },
    attrs: {
      "href": `/?ctx=${_vm.currentUserActiveSupportContext}`,
      "aria-label": "open cosmic in a new tab",
      "target": "_blank",
      "tooltip": "Open COSMIC in a new tab"
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center justify-center no-gap"
  }, [_c('c-icon-fa', {
    attrs: {
      "icon": "fad fa-browser",
      "icon-color": "currentColor",
      "icon-size": "20px"
    }
  }), _c('c-icon-fa', {
    staticStyle: {
      "margin-bottom": "13px",
      "margin-left": "-2px"
    },
    attrs: {
      "icon": "fas fa-plus",
      "icon-color": "currentColor",
      "icon-size": "14px"
    }
  })], 1)])]) : _vm._e(), _vm.currentUserHasSupportContexts ? _c('div', {
    staticClass: "nav_bar_item"
  }, [_vm.shouldShowGetSupportIcon ? _c('MenuCosmicSupportTicketTracker') : _vm._e()], 1) : _vm._e()]), _c('div', {
    staticClass: "right_side c-flex align-items-center justify-end",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm.currentUserHasSupportContexts && (_vm.shouldShowAnySharedCreate || _vm.hasApplicationSpecificCreateMenuItems) ? _c('div', {
    staticClass: "nav_bar_item"
  }, [_c('c-menu', {
    attrs: {
      "align-right": "",
      "border-color": "var(--cosmic-text)",
      "border-size": "1px",
      "nudge-top": "0px"
    }
  }, [_c('ButtonMiniActionNavbar', {
    attrs: {
      "slot": "activator",
      "icon": _vm.$icons.create_fat,
      "disable-scale-on-hover": "",
      "label": "Create a new entity",
      "tooltip": "Open create menu",
      "tooltip-position": "bottom"
    },
    slot: "activator"
  }), _vm._t("create_menu_items"), _c('hr', {
    staticClass: "my-2"
  }), _vm.shouldShowCreateMenuOrganization ? _c('c-menu-item', {
    attrs: {
      "href": `/organizations/create?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.ORGANIZATION],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Create an Organization "), _c('small', [_vm._v("Orgs typically house Inventory")])])], 1)]) : _vm._e(), _vm.shouldShowCreateMenuLocation ? _c('c-menu-item', {
    attrs: {
      "href": `/locations/create?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.LOCATION],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Create a Location "), _c('small', [_vm._v("Locations have a building, room, stock, bin")])])], 1)]) : _vm._e(), _vm.shouldShowCreateMenuOrganization || _vm.shouldShowCreateMenuLocation ? _c('hr', {
    staticClass: "my-2"
  }) : _vm._e(), _vm.shouldShowCreateMenuUser ? _c('c-menu-item', {
    attrs: {
      "href": `/users/create?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.USER],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Create a User "), _c('small', [_vm._v("Set up a new User account for COSMIC access")])])], 1)]) : _vm._e(), _vm.shouldShowCreateMenuUserGroup ? _c('c-menu-item', {
    attrs: {
      "href": `/users/groups/create?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.USER_GROUP],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Create a User Group "), _c('small', [_vm._v("Organize COSMIC Users into a new group")])])], 1)]) : _vm._e(), _vm.shouldShowCreateMenuContact ? _c('c-menu-item', {
    attrs: {
      "href": `/contacts/create?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.CONTACT],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Create a Contact "), _c('small', [_vm._v("Can be any non-COSMIC human")])])], 1)]) : _vm._e(), _vm.shouldShowCreateMenuApprovalRoutingTemplate ? _c('c-menu-item', {
    attrs: {
      "href": `/users/approval_routing_templates/create?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.APPROVAL_ROUTING_TEMPLATE],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Create an Approval Routing Template "), _c('small', [_vm._v("Build a new approval flow using ordered User Groups")])])], 1)]) : _vm._e()], 2)], 1) : _vm._e(), _c('div', {
    staticClass: "nav_bar_item"
  }, [_c('c-menu', {
    attrs: {
      "align-right": "",
      "allow-wrap": "",
      "border-color": "var(--cosmic-text)",
      "border-size": "1px",
      "max-width": "400px",
      "nudge-top": "0px"
    }
  }, [_c('ButtonMiniActionNavbar', {
    attrs: {
      "slot": "activator",
      "icon": _vm.$icons.application_reporting,
      "disable-scale-on-hover": "",
      "label": "View reports",
      "tooltip": "Open Reports menu",
      "tooltip-position": "bottom"
    },
    slot: "activator"
  }), _vm._l(_vm.reportingRoutes, function (route, index) {
    return _c('c-menu-item', {
      key: index,
      attrs: {
        "href": `${route.path}?ctx=${_vm.currentUserActiveSupportContext}`
      }
    }, [_c('div', {
      staticClass: "c-flex align-items-center no-gap"
    }, [_c('c-icon-fa', {
      staticClass: "mr-2",
      attrs: {
        "icon": index <= 9 ? `fa-duotone fa-solid fa-${index}` : _vm.$icons.application_reporting,
        "icon-color": "var(--cosmic-text)",
        "icon-size": "22px"
      }
    }), _c('div', {
      staticClass: "c-flex column no-gap"
    }, [_vm._v(" " + _vm._s(route.meta.displayName) + " "), _c('small', [_vm._v(_vm._s(route.meta.description))])])], 1)]);
  }), _c('hr', {
    staticClass: "my-2"
  }), _vm._t("reporting_menu_items"), _vm.shouldShowReportingMenu ? _c('c-menu-item', {
    attrs: {
      "href": `/reporting?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons.application_reporting,
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" View report details "), _c('small', [_vm._v("Detailed view of available reports for " + _vm._s(_vm.$cosmicApplication))])])], 1)]) : _vm._e()], 2)], 1), _vm.currentUserHasSupportContexts && _vm.shouldShowUserSupport ? _c('div', {
    ref: "support_context",
    staticClass: "nav_bar_item support_context_display"
  }, [_c('ActiveUserSupportsDisplay')], 1) : _vm._e(), _c('TheCurrentUserAvatar', {
    attrs: {
      "show-my-approval-queue-link": _vm.showMyApprovalQueueLink
    },
    scopedSlots: _vm._u([{
      key: "current_user_menu_items",
      fn: function () {
        return [_vm._t("current_user_menu_items")];
      },
      proxy: true
    }], null, true)
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };